import { POSITIVE_LIST_MEASURE_QUERY_KEY } from "./measureDetail";
import { POSITIVE_LIST_QUERY_KEY } from "./measureList";

export const positiveListDetailKey = (measureId) => [
    POSITIVE_LIST_MEASURE_QUERY_KEY,
    String(measureId),
];

const isDetailQuery = (measureId) => (query) => {
    const key = query.queryKey;

    return Array.isArray(key)
        && key[0] === POSITIVE_LIST_MEASURE_QUERY_KEY
        && String(key[1]) === String(measureId);
};

const isListQuery = (softwareId) => (query) => {
    const key = query.queryKey;

    return Array.isArray(key)
        && key[0] === POSITIVE_LIST_QUERY_KEY
        && String(key[1]) === String(softwareId);
};

const patchDetail = (queryClient, measureId, patch) => {
    const updater = (current) => ({
        ...(current && typeof current === "object" ? current : {}),
        ...patch,
    });

    queryClient.setQueryData(positiveListDetailKey(measureId), updater);
    queryClient.setQueriesData({ predicate: isDetailQuery(measureId) }, updater);
};

const patchListItem = (queryClient, softwareId, measureId, patch) => {
    queryClient.setQueriesData({ predicate: isListQuery(softwareId) }, (current) => {
        if (!current?.items) {
            return current;
        }

        return {
            ...current,
            items: current.items.map((item) => (
                String(item.id) === String(measureId)
                    ? { ...item, ...patch }
                    : item
            )),
        };
    });
};

export const patchPositiveListCaches = (queryClient, softwareId, measureId, patch) => {
    if (!patch || measureId == null) {
        return;
    }

    patchDetail(queryClient, measureId, patch);
    patchListItem(queryClient, softwareId, measureId, patch);
};

export const refreshPositiveListMeasure = async (
    queryClient,
    {
        softwareId,
        measureId,
        patch,
        confirm,
    }
) => {
    if (patch) {
        patchPositiveListCaches(queryClient, softwareId, measureId, patch);
    }

    await queryClient.refetchQueries({
        queryKey: positiveListDetailKey(measureId),
    });
    await queryClient.refetchQueries({
        predicate: isListQuery(softwareId),
    });

    const detail = queryClient.getQueryData(positiveListDetailKey(measureId));

    if (patch && typeof confirm === "function" && !confirm(detail)) {
        patchPositiveListCaches(queryClient, softwareId, measureId, patch);
    }
};

const asRecord = (value) => (
    value && typeof value === "object" && !Array.isArray(value) ? value : null
);

export const measureFromMutation = (response) => {
    const record = asRecord(response);

    if (!record) {
        return null;
    }

    if (Array.isArray(record.evidence) || Array.isArray(record.controls)) {
        return record;
    }

    if (
        record.title
        && (record.measure_type || record.measureType || record.usage_status || record.usageStatus)
    ) {
        return record;
    }

    const nested = record.measure || record.data;

    if (nested && nested !== record) {
        return measureFromMutation(nested);
    }

    return null;
};

export const evidenceFromMutation = (response) => {
    const record = asRecord(response);

    if (!record || Array.isArray(record.evidence)) {
        return null;
    }

    if (record.source_type || record.sourceType) {
        return record;
    }

    return null;
};
